import { apiClient } from "@api/apiClient";

import { DefaultRegistryAgencyResponseData } from "./registryAgencyFilter.interface";

const API_ENDPOINT = "des/ctg/filter/registry-agency/";

export const publicationRegistryAgencyApi = {
  getRegistryAgencyData: async () => {
    const response = await apiClient.get<DefaultRegistryAgencyResponseData>(
      `${API_ENDPOINT}`,
    );
    return response;
  },
};
